import React, { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";

import * as actions from "../../../../store/actions";
import { useInfiniteScroll } from "../../../../utils/pagination";

import SearchBox from "../../../../components/formElements/searchbox/SearchBox";

import PatientList from "./PatientList";

const AllPatients = ({
  patients,
  getAllPatientList,
  searchPatient,
  total_pages,
  emptyPatientList,
  
}) => {
  const [page, setPage] = useState(0);
  
  const loader = useRef(null);
  
  useInfiniteScroll(loader, () => {
    setPage(page => page + 1);
  });

  useEffect(() => {
    
    if (page > 0 && page <= total_pages && !patients?.searchedPatientsValue) {
  
      getAllPatientList(page,"");
    }
    
    else if (
     
      patients?.searchedPatientsValue &&
      patients?.searchedPatientsValue.length >= 3 &&
      page > 0 &&
      page <= total_pages

    ) {
      
  
      getAllPatientList(page,patients?.searchedPatientsValue);
    }
    // eslint-disable-next-line
  }, [page,patients?.searchedPatientsValue]);

  useEffect(() => {
    emptyPatientList("allPatients");
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="row m-0 p-0">
        <div className="col-md-12 m-0 p-0">
          <SearchBox
            value={patients?.searchedPatientsValue}
            onChange={val =>{
              searchPatient( val);
              setPage(1);
              
            }}
          />
        </div>
      </div>
      <PatientList
        patients={patients?.allPatients}
        />
      <div ref={loader}></div>
    </>
  );
};

const mapStoreToProps = ({ dashboard }) => ({
  patients: dashboard?.patients,
  total_pages: dashboard?.patients?.totalPatientPages,
  allPatients:dashboard?.patients?.allPatients,
});

const mapDispatchToProps = dispatch => ({
  getAllPatientList: (page,searchData)=> dispatch(actions.getAllPatientList(page,searchData)),
  searchPatient: searchData => dispatch(actions.searchPatient(searchData)),
  emptyPatientList: currentTab =>
    dispatch(actions.emptyPatientList(currentTab)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(AllPatients)
);
